module.exports = __webpack_public_path__ + "img/integral1.cdd8f756.png";